(function () {
    'use strict';

    angular
        .module('app')
        .controller('EmailAddressListCtrl', EmailAddressListCtrl);

    /**
     * @ngdoc controller
     * @name EmailAddressListCtrl
     *
     * @description
     * List screen for Email Addresses
     */

    EmailAddressListCtrl.$inject = [
        '$scope',
        '$q',
        'SystemService',
        'EmailAddressService',
        'DialogService',
        'NavigationAidService',
        'ChilliUserProfileService',
        'WindowTitleService'];

    function EmailAddressListCtrl(
        $scope,
        $q,
        SystemService,
        EmailAddressService,
        DialogService,
        NavigationAidService,
        ChilliUserProfileService,
        WindowTitleService) {

        var vm = this;
        vm.searchDelay = SystemService.getSearchDelay();
        vm.emailAddressCount = 0;
        vm.currentPage = 1;
        vm.loading = true;
        vm.loadingGrid = false;
        vm.permissionDenied = false;
        vm.error = null;
        vm.showUnblocked = false;
        vm.blockEmailAddresses = blockEmailAddresses;
        vm.close = close;
        vm.updateList = updateList;
        Object.defineProperty(vm, 'title', {
            get: function () { return (vm.showUnblocked ? 'Unblocked' : 'Blocked') + ' Email Addresses'; }
        });
        Object.defineProperty(vm, 'selectedEmailAddresses', {
            get: function () {
                return _(vm.emailAddresses)
                    .filter('Selected')
                    .value();
            }
        });

        activate();

        /**
         * Initialises the email address list.
         * A watch is set on the currentPage variable, when this is changed the list will be updated.
         */
        function activate() {
            WindowTitleService.setTitle(vm.title);

            ChilliUserProfileService.verifyUserIsAdministrator({
                onUserIsAdmin: loadEverything,
                onUserIsNotAdmin: function () { vm.permissionDenied = true; },
                onError: function (response) { DialogService.error('Error loading User profile', response); },
                onFinally: function () { vm.loading = false; }
            });

            function loadEverything() {
                return SystemService.getMenuListSize('Email Addresses')
                    .then(getListPageSizeOk, getListPageSizeError);
            }

            function getListPageSizeOk(data) {
                vm.listPageSize = data;

                $scope.$watch('vm.searchText', function (newVal, oldVal) {
                    if (newVal !== oldVal) {
                        updateList();
                    }
                });

                $scope.$watch('vm.currentPage', function (newVal, oldVal) {
                    if (newVal !== oldVal) {
                        updateList();
                    }
                });

                $scope.$watch('vm.showUnblocked', function (newVal, oldVal) {
                    if (newVal !== oldVal) {
                        updateList();
                    }
                });

                updateList();
            }

            function getListPageSizeError(response) {
                DialogService.error('Error fetching list size', response);
            }
        }

        /**
         * Refreshes the email address list.
         */
        function updateList() {
            if (updateList.currentPromise === undefined) {
                updateList.currentPromise = null;
            }
            vm.loadingGrid = true;

            var getPromise = EmailAddressService.query({
                genericSearch: vm.searchText,
                currentPage: vm.currentPage,
                pageSize: vm.listPageSize,
                Blocked: !vm.showUnblocked
            })
                .then(getEmailAddressOk, getEmailAddressError)
                .then(function () {
                    vm.loadingGrid = false;
                });

            updateList.currentPromise = getPromise;

            return getPromise;

            function getEmailAddressOk(data) {
                if (getPromise === updateList.currentPromise) {
                    vm.error = null;
                    vm.emailAddresses = data.EmailAddresses;
                    vm.emailAddressesCount = data.EmailAddressesCount;
                }
                else {
                    return $q.reject();
                }
            }

            function getEmailAddressError(response) {
                if (getPromise === updateList.currentPromise) {
                    vm.error = response;
                }
                else {
                    return $q.reject();
                }
            }
        }

        /**
         * Blocks/Unblocks the currently selected email addresses
         *
         * @param {bool} block - If false the email addresses will be unblocked, otherwise they will be blocked.
         */
        function blockEmailAddresses(block) {
            if (ensureEmailAddressesSelection()) {
                var selectedEmailAddressIds = _.map(vm.selectedEmailAddresses, 'Id');

                var emailAddressLabel = 'Email Address';
                if (selectedEmailAddressIds.length > 1) {
                    emailAddressLabel += 'es';
                }

                DialogService
                    .confirm((block ? 'Block' : 'Unblock') + ' the ' + selectedEmailAddressIds.length + ' selected ' + emailAddressLabel + '?')
                        .then(function () {
                            EmailAddressService.block(selectedEmailAddressIds, block)
                                .then(blockEmailAddressesOk, blockEmailAddressesError);
                        });
            }

            function blockEmailAddressesOk(response) {
                updateList();
            }

            function blockEmailAddressesError(response) {
                DialogService.error('Error ' + (block ? 'blocking' : 'unblocking') + ' Email Address(es)', response);
            }
        }

        /**
         * Ensure at least one email address is selected.
         * Displays a dialog 'No Email Addresses were selected' if no email addresses are selected.
         * @return {bool} true if at least one email address is selected, else false
         */
        function ensureEmailAddressesSelection() {
            if (vm.selectedEmailAddresses.length === 0) {
                DialogService.alert('No Email Addresses were selected');
                return false;
            } else {
                return true;
            }
        }

        /**
         * 'Close' the current view by navigating back to the previous page
         */
        function close() {
            NavigationAidService.goBack();
        }
    }
})();